import { render, staticRenderFns } from "./GeneralSettingsBrand.vue?vue&type=template&id=4aef4d4e&"
import script from "./GeneralSettingsBrand.vue?vue&type=script&lang=ts&"
export * from "./GeneralSettingsBrand.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports